<template>
  <div class="layout" :style="layout.isBack?{backgroundImage: 'url('+background+')'}:{}">
    <div class="title" :style="{height:layout.height}">
        <p class="title_ch" :style="{paddingTop:layout.paddingTop}">{{message.ch}}</p>
        <p class="title_en">{{message.en}}</p>
        <img :style="{top:layout.top}" src="../assets/images/new_image/title.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props:{
    message:{
      type:Object,
      default:{}
    },
    layout:{
      type:Object,
      default:{}
    }
  },
  data(){
    return {
      background:require("../assets/images/new_image/title_bg.png")
    }
  }
}
</script>

<style lang="less" scoped>
.layout{
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .title{
    // background-image: url('../assets/images/new_image/title_bg.png');
    // height: 341px;
    text-align: center;
    position: relative;

    &_ch{
      // padding-top: 81px;
      color: #333333;
      font-size: 40px;
    }

    &_en{
      font-size: 28px;
      color: #999999;
      margin-top: 10px;
      font-weight: 200;
    }

    img{
      position: absolute;
      // top: 75px;
      left: 50%;
      transform: translateX(-50%);
      width: 974px;
      height: 60px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/title.vue